import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    company: null,
    loading: false,
    error: false
};

export const companySlice = createSlice({
    name: 'company',
    initialState,
    reducers: {
        companyRegisterStart: (state) => {
            state.loading = true;
            state.error = false;
        },
        companyRegisterSuccess: (state, action) => {
            state.company = action.payload;
            state.loading = false;
        },
        companyRegisterFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {companyRegisterStart, companyRegisterSuccess, companyRegisterFailure} = companySlice.actions;

export default companySlice.reducer;